export const boxes = [
  { house_nr: '1371', x: '3710.5', y: '457.5', width: '48' },
  { house_nr: '1363', x: '3489.5', y: '470.5', width: '48' },
  { house_nr: '1362', x: '3449.5', y: '541.5', width: '48' },
  { house_nr: '1361', x: '3607.5', y: '482.5', width: '73' },
  { house_nr: '1351', x: '3809.5', y: '430.5', width: '48' },
  { house_nr: '1345', x: '4234.5', y: '281.5', width: '48' },
  { house_nr: '1341', x: '4169.5', y: '279.5', width: '48' },
  { house_nr: '1314', x: '4074.5', y: '418.5', width: '48' },
  { house_nr: '1313', x: '4028.5', y: '368.5', width: '48' },
  { house_nr: '1312', x: '3869.5', y: '376.5', width: '48' },
  { house_nr: '1311', x: '3941.5', y: '353.5', width: '48' },
  { house_nr: '1212', x: '3030.5', y: '791.5', width: '48' },
  { house_nr: '1131', x: '4418.5', y: '506.5', width: '48' },
  { house_nr: '1122', x: '4318.5', y: '378.5', width: '48' },
  { house_nr: '1121', x: '4226.5', y: '375.5', width: '48' },
  { house_nr: '1113', x: '4187.5', y: '424.5', width: '48' },
  { house_nr: '1112', x: '4161.5', y: '557.5', width: '48' },
  { house_nr: '1111', x: '4129.5', y: '481.5', width: '48' },
  { house_nr: '1061', x: '3893.5', y: '610.5', width: '73' },
  { house_nr: '1052', x: '4047.5', y: '696.5', width: '73' },
  { house_nr: '1051', x: '4121.5', y: '613.5', width: '73' },
  { house_nr: '1041', x: '3194.5', y: '568.5', width: '48' },
  { house_nr: '1032', x: '3294.5', y: '495.5', width: '48' },
  { house_nr: '1031', x: '3374.5', y: '510.5', width: '48' },
  { house_nr: '1024', x: '3769.5', y: '573.5', width: '48' },
  { house_nr: '1022', x: '3818.5', y: '617.5', width: '48' },
  { house_nr: '1021', x: '3609.5', y: '651.5', width: '48' },
  { house_nr: '1013', x: '3558.5', y: '351.5', width: '48' },
  { house_nr: '1012', x: '3350.5', y: '431.5', width: '48' },
  { house_nr: '1011', x: '3464.5', y: '347.5', width: '48' },
  { house_nr: '931', x: '2899.5', y: '295.5', width: '48' },
  { house_nr: '912', x: '3198.5', y: '409.5', width: '48' },
  { house_nr: '911', x: '3174.5', y: '300.5', width: '73' },
  { house_nr: '892', x: '2119.5', y: '1052.5', width: '48' },
  { house_nr: '891', x: '1692.5', y: '1131.5', width: '48' },
  { house_nr: '852', x: '1621.5', y: '1217.5', width: '48' },
  { house_nr: '851', x: '1931.5', y: '1270.5', width: '73' },
  { house_nr: '842', x: '2230.5', y: '891.5', width: '48' },
  { house_nr: '841', x: '2344.5', y: '983.5', width: '48' },
  { house_nr: '832', x: '2235.5', y: '1029.5', width: '48' },
  { house_nr: '821', x: '2180.5', y: '1161.5', width: '48' },
  { house_nr: '812', x: '1955.5', y: '1109.5', width: '48' },
  { house_nr: '811', x: '2028.5', y: '1071.5', width: '48' },
  { house_nr: '761', x: '3028.5', y: '611.5', width: '73' },
  { house_nr: '752', x: '2756.5', y: '786.5', width: '48' },
  { house_nr: '751', x: '2867.5', y: '750.5', width: '48' },
  { house_nr: '741', x: '2747.5', y: '641.5', width: '73' },
  { house_nr: '731', x: '3131.5', y: '449.5', width: '48' },
  { house_nr: '723', x: '2739.5', y: '515.5', width: '48' },
  { house_nr: '722', x: '2769.5', y: '569.5', width: '48' },
  { house_nr: '721', x: '2914.5', y: '471.5', width: '48' },
  { house_nr: '713', x: '2907.5', y: '644.5', width: '48' },
  { house_nr: '712', x: '2818.5', y: '601.5', width: '48' },
  { house_nr: '711', x: '2932.5', y: '543.5', width: '48' },
  { house_nr: '695', x: '2506.5', y: '378.5', width: '73' },
  { house_nr: '694', x: '2835.5', y: '302.5', width: '48' },
  { house_nr: '693', x: '2413.5', y: '424.5', width: '73' },
  { house_nr: '692', x: '2741.5', y: '367.5', width: '48' },
  { house_nr: '691', x: '2739.5', y: '246.5', width: '73' },
  { house_nr: '643', x: '2657.5', y: '222.5', width: '48' },
  { house_nr: '642', x: '2596.5', y: '207.5', width: '48' },
  { house_nr: '641', x: '2613.5', y: '346.5', width: '48' },
  { house_nr: '622', x: '2526.5', y: '215.5', width: '48' },
  { house_nr: '621', x: '2447.5', y: '243.5', width: '69' },
  { house_nr: '614', x: '2262.5', y: '214.5', width: '48' },
  { house_nr: '613', x: '2422.5', y: '212.5', width: '48' },
  { house_nr: '612', x: '2368.5', y: '212.5', width: '48' },
  { house_nr: '611', x: '2242.5', y: '268.5', width: '48' },
  { house_nr: '551', x: '1737.5', y: '812.5', width: '48' },
  { house_nr: '534', x: '1672.5', y: '947.5', width: '73' },
  { house_nr: '533', x: '1626.5', y: '984.5', width: '48' },
  { house_nr: '532', x: '1460.5', y: '838.5', width: '48' },
  { house_nr: '531', x: '1582.5', y: '854.5', width: '48' },
  { house_nr: '514', x: '1190.5', y: '994.5', width: '48' },
  { house_nr: '513', x: '1122.5', y: '1045.5', width: '48' },
  { house_nr: '512', x: '1378.5', y: '1072.5', width: '48' },
  { house_nr: '511', x: '1286.5', y: '995.5', width: '48' },
  { house_nr: '494', x: '1873.5', y: '403.5', width: '48' },
  { house_nr: '493', x: '2061.5', y: '292.5', width: '48' },
  { house_nr: '492', x: '2012.5', y: '422.5', width: '48' },
  { house_nr: '491', x: '1906.5', y: '315.5', width: '48' },
  { house_nr: '382', x: '834.5', y: '584.5', width: '48' },
  { house_nr: '383', x: '708.5', y: '592.5', width: '48' },
  { house_nr: '381', x: '649.5', y: '653.5', width: '73' },
  { house_nr: '371', x: '831.5', y: '883.5', width: '48' },
  { house_nr: '362', x: '1026.5', y: '401.5', width: '48' },
  { house_nr: '361', x: '732.5', y: '401.5', width: '48' },
  { house_nr: '352', x: '744.5', y: '1069.5', width: '48' },
  { house_nr: '351', x: '741.5', y: '962.5', width: '48' },
  { house_nr: '341', x: '1277.5', y: '900.5', width: '73' },
  { house_nr: '334', x: '1181.5', y: '835.5', width: '48' },
  { house_nr: '333', x: '1032.5', y: '885.5', width: '73' },
  { house_nr: '332', x: '907.5', y: '819.5', width: '48' },
  { house_nr: '331', x: '1121.5', y: '701.5', width: '73' },
  { house_nr: '323', x: '757.5', y: '712.5', width: '48' },
  { house_nr: '322', x: '707.5', y: '748.5', width: '48' },
  { house_nr: '321', x: '923.5', y: '696.5', width: '73' },
  { house_nr: '312', x: '1156.5', y: '566.5', width: '48' },
  { house_nr: '311', x: '901.5', y: '628.5', width: '73' },
  { house_nr: '231', x: '469.5', y: '690.5', width: '48' },
  { house_nr: '222', x: '455.5', y: '844.5', width: '48' },
  { house_nr: '221', x: '614.5', y: '761.5', width: '48' },
  { house_nr: '211', x: '389.5', y: '701.5', width: '48' },
  { house_nr: '141', x: '171.5', y: '478.5', width: '48' },
  { house_nr: '131', x: '273.5', y: '780.5', width: '48' },
  { house_nr: '122', x: '366.5', y: '555.5', width: '48' },
  { house_nr: '112', x: '181.5', y: '693.5', width: '48' },
  { house_nr: '111', x: '236.5', y: '571.5', width: '73' },
];
